/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-children-prop */
import React, { useState, useEffect, Dispatch, SetStateAction } from 'react'
import ReactMarkdown from 'react-markdown'

import {
	Button,
	ModalBase,
	QuestionComment,
	QuestionHistoric,
	QuestionNotebook,
	QuestionReminder,
	QuestionStatistics,
	RadioButton,
	Title,
} from '@components/atoms'
import {
	Dismiss20Regular,
	Chat16Regular,
	Book24Regular,
	Document16Regular,
	ErrorCircle16Regular,
	DataHistogram20Regular,
	DismissCircle20Regular,
	Checkmark20Regular,
} from '@fluentui/react-icons'
import { RadioGroup } from '@headlessui/react'
import { useIsMobile } from '@hooks'
import { QuestionType } from '@models/questions.model'
import { notebookAPI } from '@services/NotebookAPI'
import { questionsAPI } from '@services/QuestionsAPI'
import { simulatedAPI } from '@services/SimulatedAPI'
import { modalCreators } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import rehypeRaw from 'rehype-raw'

import { ContainerTitle, ContainerDesc, questionStyles } from './styles'

const {
	container,
	containerQuestion,
	numberContainer,
	radioGroup,
	errorSpan,
	hitSpan,
	deleteSpan,
	containerDeleteQuestionNotebook,
	containerButton,
	containerButtonMobile,
	containerActionBar,
	Icon,
	ActionBar,
	feedbackContainer,
} = questionStyles

interface QuestionProps {
	value: QuestionType
	index?: string | number
	setValue?: Dispatch<SetStateAction<Array<QuestionType>>> | undefined
	notebookQuestionId?: string
	mockID?: string
	showActionbar?: boolean
}

const Question = ({
	value,
	index,
	setValue,
	notebookQuestionId = '',
	mockID = '',
	showActionbar = true,
	...props
}: QuestionProps) => {
	const {
		fonts: { fontSize },
		premium,
	} = useAppSelector((state) => state)
	const dispatch = useAppDispatch()
	const [answer, setAnswer] = useState()
	const [actionBarValue, setActionBarValue] = useState('')
	const [openModalDeleteNotebookQuestion, setOpenModalDeleteNotebookQuestion] =
		useState(false)

	const [PostAnswerQuestionMutation, { data, isSuccess }] =
		questionsAPI.usePostAnswerQuestionMutation()

	const [
		PostAnswerQuestionTestSimualation,
		{ data: dataTestSimulation, isSuccess: isSuccessTestSimulation },
	] = simulatedAPI.usePostAnswerTestQuestionSimulateMutation()

	const [DeleteNotebookQuestion, { isSuccess: isSuccessNotebookQuestion }] =
		notebookAPI.useDeleteNotebookQuestionMutation()

	const isMobile = useIsMobile()

	const isFree = !premium.value

	const handleAnswerResponse = () => {
		if (mockID) {
			return PostAnswerQuestionTestSimualation({
				questionId: value.id,
				answer,
				mockID,
			})
		}

		return PostAnswerQuestionMutation({
			questionId: value.id,
			clientResponse: answer,
		})
	}

	const handleDeleteNotebookQuestion = () => {
		if (notebookQuestionId) {
			DeleteNotebookQuestion({
				notebookId: notebookQuestionId,
				questionId: value.id,
			})
		}
	}

	const handleActionBar = (name: string) => {
		if (name === actionBarValue) {
			setActionBarValue('')
		} else {
			setActionBarValue(name)
		}
	}

	const answerCheck = () => {
		if (answer) {
			return data?.isCorrect ? 'Verdadeiro' : 'Falso'
		}

		return data?.isCorrect ? 'Falso' : 'Verdadeiro'
	}

	useEffect(() => {
		if (isSuccess && data) {
			if (setValue) {
				setValue((prev) => {
					const newdArray = prev.map((item) =>
						item.id === value.id
							? {
									...item,
									feedback: `Gabarito ${answerCheck()}`,
									feedbackText: data?.answerHtml || '',
									answer,
									isCorrect: data?.isCorrect,
							  }
							: item
					)

					return newdArray
				})
			}

			if (data?.blackFridayModal && isFree) {
				dispatch(
					modalCreators.openModal({
						name: 'blackFriday',
					})
				)
			}
			if (data?.showCorrectQuestionsPopup && isFree) {
				dispatch(
					modalCreators.openModal({
						name: 'freeSevenQuestions',
						modalInfo: {
							title: 'Você acertou mais de 70% das questões respondidas!',
							noShowInfo: false,
							button: {
								icon: 'coupon',
								label: 'Quero meu cupom',
							},
						},
					})
				)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, isSuccess])

	useEffect(() => {
		if (isSuccessTestSimulation && dataTestSimulation) {
			if (setValue) {
				setValue((prev) => {
					const newdArray = prev.map((item) =>
						item.id === value.id
							? {
									...item,
									feedback: `Gabarito ${answerCheck()}`,
									feedbackText: dataTestSimulation?.answerHtml || '',
									answer,
									isCorrect: dataTestSimulation?.isCorrect,
							  }
							: item
					)

					return newdArray
				})
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataTestSimulation, isSuccessTestSimulation])

	useEffect(() => {
		if (isSuccessNotebookQuestion) {
			if (setValue) {
				setValue((prev) => {
					const newdArray = prev.filter(
						(item: QuestionType) => item.id !== value.id
					)

					return newdArray
				})
				setOpenModalDeleteNotebookQuestion(false)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccessNotebookQuestion])

	return (
		<>
			<div className={container()}>
				<div className={containerQuestion()} {...props}>
					<ContainerTitle>
						<div className={numberContainer()}>{index}</div>
						<ContainerDesc fontSize={fontSize}>
							<h6>{value?.title}</h6>
						</ContainerDesc>
					</ContainerTitle>
					<ContainerDesc fontSize={fontSize}>
						<p dangerouslySetInnerHTML={{ __html: value?.description || '' }} />
					</ContainerDesc>
				</div>

				{notebookQuestionId ? (
					<div className={containerDeleteQuestionNotebook()}>
						<button
							type='button'
							onClick={() => {
								setOpenModalDeleteNotebookQuestion(
									!openModalDeleteNotebookQuestion
								)
							}}
						>
							<span className={deleteSpan()}>
								Excluir questão <DismissCircle20Regular />
							</span>
						</button>
					</div>
				) : null}

				<RadioGroup
					value={answer}
					onChange={setAnswer}
					className={radioGroup()}
					disabled={isSuccess || isSuccessTestSimulation}
				>
					<RadioGroup.Option value>
						{({ checked }) => (
							<RadioButton
								questionType
								checked={checked}
								questionAnswer={isSuccess || isSuccessTestSimulation}
								isCorrect={
									mockID ? dataTestSimulation?.isCorrect : data?.isCorrect
								}
							/>
						)}
					</RadioGroup.Option>
					<RadioGroup.Option value={false}>
						{({ checked }) => (
							<RadioButton
								questionType={false}
								checked={checked}
								questionAnswer={isSuccess || isSuccessTestSimulation}
								isCorrect={
									mockID ? dataTestSimulation?.isCorrect : data?.isCorrect
								}
							/>
						)}
					</RadioGroup.Option>
				</RadioGroup>

				{isMobile && (
					<div className={containerButtonMobile()}>
						{value.lastResponseIncorrect !== null &&
						value.lastResponseIncorrect === 1 ? (
							<span className={errorSpan()}>
								Errou anteriormente <Dismiss20Regular />
							</span>
						) : value.lastResponseIncorrect === 0 ? (
							<span className={hitSpan()}>
								Acertou anteriormente <Checkmark20Regular />
							</span>
						) : (
							''
						)}

						<Button
							css={{ marginTop: '10px' }}
							onClick={handleAnswerResponse}
							disabled={isSuccess || isSuccessTestSimulation}
						>
							Responder
						</Button>
					</div>
				)}

				{!isMobile && (
					<div className={containerButton()}>
						<Button
							css={{ maxWidth: '329px' }}
							onClick={handleAnswerResponse}
							disabled={isSuccess || isSuccessTestSimulation}
						>
							Responder
						</Button>

						{value.lastResponseIncorrect !== null &&
						value.lastResponseIncorrect === 1 ? (
							<span className={errorSpan()}>
								Errou anteriormente <Dismiss20Regular />
							</span>
						) : value.lastResponseIncorrect === 0 ? (
							<span className={hitSpan()}>
								Acertou anteriormente <Checkmark20Regular />
							</span>
						) : (
							''
						)}
					</div>
				)}

				{isSuccess && (
					<div className={feedbackContainer()}>
						<ReactMarkdown
							rehypePlugins={[rehypeRaw]}
							children={data?.answerHtml || ''}
						/>
					</div>
				)}

				{isSuccessTestSimulation && (
					<div className={feedbackContainer()}>
						<ReactMarkdown
							rehypePlugins={[rehypeRaw]}
							children={dataTestSimulation?.answerHtml || ''}
						/>
					</div>
				)}

				{showActionbar && (
					<div className={containerActionBar()}>
						<ActionBar
							selected={actionBarValue === 'comment'}
							onClick={() => {
								handleActionBar('comment')
							}}
						>
							<Icon>
								<Chat16Regular />
							</Icon>
							<p>Comentários</p>
						</ActionBar>
						<ActionBar
							selected={actionBarValue === 'notebook'}
							onClick={() => {
								handleActionBar('notebook')
							}}
						>
							<Icon>
								<Book24Regular />
							</Icon>
							<p>Cadernos</p>
						</ActionBar>
						<ActionBar
							selected={actionBarValue === 'reminder'}
							onClick={() => {
								handleActionBar('reminder')
							}}
						>
							<Icon>
								<Document16Regular />
							</Icon>
							<p>Lembrete</p>
						</ActionBar>
						<ActionBar
							selected={actionBarValue === 'error'}
							onClick={() => {
								handleActionBar('error')
								dispatch(
									modalCreators.openModal({
										name: 'questionErrorReport',
										modalInfo: {
											title: 'Reportar erro',
											questionId: value.id,
										},
									})
								)
							}}
						>
							<Icon>
								<ErrorCircle16Regular />
							</Icon>
							<p>Reportar erro</p>
						</ActionBar>
						<ActionBar
							selected={actionBarValue === 'historic'}
							onClick={() => {
								handleActionBar('historic')
							}}
						>
							<Icon>
								<ErrorCircle16Regular />
							</Icon>
							<p>Histórico de Respostas</p>
						</ActionBar>
						<ActionBar
							selected={actionBarValue === 'statistic'}
							onClick={() => {
								handleActionBar('statistic')
							}}
						>
							<Icon>
								<DataHistogram20Regular />
							</Icon>
							<p>Estatisticas</p>
						</ActionBar>
					</div>
				)}

				{isMobile && <div style={{ marginBottom: '32px' }} />}

				{actionBarValue === 'comment' && <QuestionComment id={value.id} />}
				{actionBarValue === 'reminder' && <QuestionReminder id={value.id} />}
				{actionBarValue === 'notebook' && <QuestionNotebook id={value.id} />}
				{actionBarValue === 'historic' && <QuestionHistoric id={value.id} />}
				{actionBarValue === 'statistic' && <QuestionStatistics id={value.id} />}
			</div>

			<ModalBase
				title='Excluir questão'
				open={openModalDeleteNotebookQuestion}
				onOpenChange={setOpenModalDeleteNotebookQuestion}
			>
				<div>
					<Title variant='h4' color='$neutral160'>
						Deseja apagar esta questão?
					</Title>
					<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
						<Button onClick={handleDeleteNotebookQuestion}>Apagar</Button>
						<Button
							outlined
							onClick={() => {
								setOpenModalDeleteNotebookQuestion(
									!openModalDeleteNotebookQuestion
								)
							}}
						>
							Cancelar
						</Button>
					</div>
				</div>
			</ModalBase>
		</>
	)
}

export { Question }
